.tutorial-layer {
	--tutorial-ink: #252134;
	--tutorial-panel-edge: 20px;
	position: fixed;
	z-index: 120;
	inset: 0;
	color: #302c42;
	pointer-events: none;
}

.tutorial-spotlight,
.tutorial-hit-target {
	position: fixed;
	border-radius: 0;
}

.tutorial-spotlight {
	z-index: 5;
	border: 3px solid var(--tutorial-ink);
	background: rgba(255, 212, 71, 0.18);
	box-shadow: 6px 6px 0 #ffd447;
	pointer-events: none;
	animation: tutorial-pulse 1.1s ease-in-out infinite alternate;
}

.tutorial-spotlight.drag-source::after,
.tutorial-spotlight.drag-destination::after {
	position: absolute;
	top: -24px;
	left: 50%;
	padding: 5px 9px;
	border: 2px solid var(--tutorial-ink);
	border-radius: 0;
	color: var(--tutorial-ink);
	background: #ffcf4a;
	box-shadow: none;
	font-size: 14px;
	font-style: normal;
	font-weight: 900;
	line-height: 1.2;
	transform: translateX(-50%);
}

.tutorial-spotlight.drag-source::after,
.tutorial-spotlight.drag-destination::after {
	content: attr(data-label);
}

.tutorial-hit-target {
	z-index: 6;
	padding: 0;
	border: 0;
	background: transparent;
	cursor: pointer;
	pointer-events: auto;
}

.tutorial-hit-target:focus-visible {
	outline: 4px solid #fff;
	outline-offset: 5px;
}

.tutorial-card {
	position: fixed;
	z-index: 3;
	right: var(--tutorial-panel-edge);
	bottom: var(--tutorial-panel-edge);
	width: min(430px, calc(100vw - 40px));
	padding: 0 0 18px;
	overflow: hidden;
	border: 2px solid var(--tutorial-ink);
	border-radius: 0;
	background: #fff;
	box-shadow: 9px 9px 0 rgba(37, 33, 52, 0.28);
	pointer-events: auto;
	transition: transform 360ms cubic-bezier(0.22, 1, 0.36, 1);
}

.tutorial-card-welcome {
	transform: translate(
		calc(-50vw + 50% + var(--tutorial-panel-edge)),
		calc(-50vh + 50% + var(--tutorial-panel-edge))
	);
}

.tutorial-card-head {
	display: flex;
	min-height: 48px;
	align-items: center;
	justify-content: space-between;
	gap: 0;
	border-bottom: 2px solid var(--tutorial-ink);
	background: #ffd447;
}

.tutorial-card-head > span {
	min-width: 0;
	flex: 1;
	padding: 0 14px;
	color: var(--tutorial-ink);
	font-family: var(--font-mono);
	font-size: 14px;
	font-weight: 800;
	letter-spacing: 0.09em;
	text-transform: uppercase;
}

.tutorial-skip {
	align-self: stretch;
	padding: 0 12px;
	border: 0;
	border-left: 2px solid var(--tutorial-ink);
	border-radius: 0;
	color: var(--tutorial-ink);
	background: #fff;
	cursor: pointer;
	font-size: 14px;
	font-weight: 800;
}

.tutorial-skip:hover {
	color: #fff;
	background: #ff637a;
}

.tutorial-drag-handle {
	display: grid;
	width: 48px;
	height: auto;
	align-self: stretch;
	margin-left: auto;
	padding: 0;
	place-items: center;
	border: 0;
	border-left: 2px solid var(--tutorial-ink);
	border-radius: 0;
	color: var(--tutorial-ink);
	background: #fff;
	cursor: grab;
	font-size: 17px;
	line-height: 1;
	touch-action: none;
	user-select: none;
}

.tutorial-drag-handle:hover {
	color: #fff;
	background: var(--purple);
}

.tutorial-drag-handle:active {
	cursor: grabbing;
}

.tutorial-card h2 {
	margin: 0;
	padding: 16px 18px 7px;
	font-size: 23px;
}

.tutorial-card p {
	margin: 0;
	padding: 0 18px;
	color: #6f697b;
	font-size: 14px;
	line-height: 1.65;
}

.tutorial-instruction {
	display: flex;
	min-height: 44px;
	margin: 14px 18px 0;
	padding: 8px 10px;
	align-items: center;
	gap: 8px;
	border: 2px solid var(--tutorial-ink);
	color: #494357;
	background: #fff7d7;
	font-size: 14px;
	font-weight: 800;
}

.tutorial-instruction i {
	width: 9px;
	height: 9px;
	border-radius: 0;
	background: #ffcf4a;
	box-shadow: 0 0 0 5px rgba(255, 207, 74, 0.2);
	animation: tutorial-pulse 0.8s ease-in-out infinite alternate;
}

.tutorial-continue {
	width: calc(100% - 36px);
	margin: 17px 18px 0;
	padding: 11px 16px;
	border: 2px solid var(--tutorial-ink);
	border-radius: 0;
	color: #fff;
	background: #5f51d8;
	cursor: pointer;
	font-size: 14px;
	font-weight: 800;
}

.tutorial-continue:hover {
	background: #4e41c2;
}

.tutorial-progress {
	display: flex;
	gap: 0;
	margin: 15px 18px 0;
	border: 2px solid var(--tutorial-ink);
}

.tutorial-progress i {
	height: 7px;
	flex: 1;
	border-right: 1px solid var(--tutorial-ink);
	border-radius: 0;
	background: #e5e2ea;
}

.tutorial-progress i.active {
	background: #6c5ce7;
}
.tutorial-progress i:last-child {
	border-right: 0;
}

@keyframes tutorial-pulse {
	from {
		opacity: 0.72;
	}
	to {
		opacity: 1;
	}
}

@media (max-width: 540px) {
	.tutorial-layer {
		--tutorial-panel-edge: 10px;
	}

	.tutorial-card {
		width: min(430px, calc(100vw - 20px));
		padding-bottom: 14px;
	}

	.tutorial-card h2 {
		margin-top: 10px;
		font-size: 18px;
	}
	.tutorial-card p {
		font-size: 14px;
		line-height: 1.5;
	}
}

@media (prefers-reduced-motion: reduce) {
	.tutorial-spotlight,
	.tutorial-instruction i {
		animation: none;
	}

	.tutorial-card {
		transition: none;
	}
}
